import { useNavigate } from 'react-router-dom'
import { SiteHeader } from '../components/SiteHeader'
import { OrgProfilePanel } from '../components/org/OrgProfilePanel'

/**
 * /account/company — desktop. The company record: who you are on Diaex, what
 * your verification state means for everyone on your team, and (owner/admin)
 * the edit form. A plain member gets the read-only view, never a 403 page.
 */
export function AccountOrg() {
  const navigate = useNavigate()
  return (
    <>
      <SiteHeader />
      <main className="min-h-[60vh] pb-16">
        <OrgProfilePanel onBack={() => navigate('/search')} />
      </main>
    </>
  )
}
